define(function(require) {
    // GEO09E01_CS_FRA_GEN layer definition config
    return {
        LAYER_ID : "GEO09E01_CS_FRA_GEN",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_CS_FRA", NAME : "Code", DATA_TYPE : "STRING"},
            {ID : "NOM_OFFCL_CS_FRA", NAME : "Nom", DATA_TYPE : "STRING"},
            {ID : "NOM_SITE_WEB_GDUNO", NAME : "Site web", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Centre de services scolaire francophone",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(57,204,253,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 4
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(60,192,236,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Centre de services scolaire francophone",
            FEATURE_ID_DATACOLUMN : "CD_CS_FRA",
            FEATURE_NAME_DATACOLUMN : "NOM_OFFCL_CS_FRA",
            DATATIP_DATACOLUMNS : ["CD_CS_FRA", "NOM_OFFCL_CS_FRA"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_CS_FRA", "NOM_OFFCL_CS_FRA", "NOM_SITE_WEB_GDUNO"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_CS_FRA", "NOM_OFFCL_CS_FRA", "NOM_SITE_WEB_GDUNO"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_CS_FRA", "NOM_OFFCL_CS_FRA"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_OFFCL_CS_FRA",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
        ZOOM_LAYERING : {
            BASE_LAYER_ID : "GEO09E01_CS_FRA",
            QUERY_EXPRESSION : {
                LOGICAL_OPERATOR : null,
                QUERIES : [{FIELD : "CD_CS_FRA", OPERATOR : "=", VALUE : undefined}]
            },
            SWITCH_SCALE : 100000
        }
    };
});
